import Component from './Tags';

export default Component;
